<template>
  <div class="set_smail_line">
    <el-form v-if="type=='Edit'" :model="passForm" :rules="passRules" ref="passForm" :hide-required-asterisk='true' class="set_form">
      <el-form-item :label="$t('colon.email')" class="info_box" prop="email">
        <el-input class="info_ipt" v-model="passForm.email"></el-input>
      </el-form-item>
      <div class="set_btn">
        <el-button @click="resetForm('passForm')">{{ $t('base.cancel') }}</el-button>
        <el-button type="primary" @click="submitForm('passForm')">{{ $t('base.save') }}</el-button>
      </div>
    </el-form>
    <el-form v-if="type=='Verjfy'" :model="codeForm" ref="codeForm" :hide-required-asterisk='true' class="set_form verhfy_box">
      <div class="set_verjfy">We sent an email with a security code to 3*******9@qq.com</div>
      <el-input class="info_ipt" v-model="codeForm.code" :placeholder="$t('base.securityCode')" maxlength="6"></el-input>
      <div class="set_btn">
        <el-button @click="resetForm('codeForm')">{{ $t('base.cancel') }}</el-button>
        <el-button type="info" disabled v-if="codeForm.code==''">{{ $t('base.verify') }}</el-button>
        <el-button type="primary" @click="submitForm('codeForm')" v-if="codeForm.code!=''">{{ $t('base.verify') }}</el-button>
      </div>
      <div class="set_nocode">No code? <span class="text_blue">Get another one</span></div>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'emailbox',
    data () {
      
      return {
        passForm:{
          email:"",
        },
        codeForm:{
          code:"",
        },
        passRules:{
          email: [
            { required: true, message: 'Invalid email. Please check and try again.', trigger: 'blur' },
            { type:'email', message: 'Invalid email. Please check and try again.', trigger: 'blur' },
          ],
        }
      }
    },
    props: {
        list: Object,
        type:String
    },
    methods: {
      submitForm(formName) {
        this.$emit('getData',this.list,'email')
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            alert('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        if(formName=='codeForm'){
          this.codeForm.code="";
        }else{
          this.$refs[formName].resetFields();
        }
        this.$emit('getData',this.list,'email')
      }
  } 
  }
</script>

<style scoped>
@import "../../../static/css/settings.css";
</style>
          


// WEBPACK FOOTER //
// src/components/form/email.vue